import React from 'react';
import { NewExistingSegment, NewExistingValue } from '../../../../../components/shared';

interface ProductionMeterSelectorProps {
  onProductionMeterNewExistingChange: (value: NewExistingValue) => void;
  onProductionMeterNameModelChange: (value: string) => void;
  productionMeterNewExisting?: NewExistingValue;
  productionMeterNameModel?: string;
  isLoading: boolean;
  error?: string;
  isEnabled: boolean;
}

export const ProductionMeterSelector: React.FC<ProductionMeterSelectorProps> = ({
  onProductionMeterNewExistingChange,
  onProductionMeterNameModelChange,
  productionMeterNewExisting,
  productionMeterNameModel,
  isLoading,
  error,
  isEnabled
}) => {

  if (!isEnabled) {
    return (
      <div className="text-center py-8">
        <div className="text-gray-400 mb-2">
          <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <p className="text-gray-500 text-xs 3xl:text-sm">Select a task to configure Production Meter details</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="block text-xs 3xl:text-sm font-semibold text-slate-700 mb-1">
          Production Meter Name/Model
        </label>
        {isEnabled && (
          <NewExistingSegment
            value={productionMeterNewExisting || null}
            onChange={onProductionMeterNewExistingChange}
            disabled={!isEnabled}
          />
        )}
      </div>
      <input
        type="text"
        value={productionMeterNameModel || ''}
        onChange={(e) => onProductionMeterNameModelChange(e.target.value)}
        className="w-full px-2 py-1.5 text-xs 3xl:text-sm placeholder:text-[11px] 3xl:placeholder:text-xs border border-slate-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed"
        placeholder="Enter production meter name/model..."
        disabled={!isEnabled}
      />
    </div>
  );
};
